import Button from "@components/atoms/button";
import { homeActions } from "@components/features/home/home.slice";
import ProfileStats from "@components/features/profile/atom/profile-stats";
import Stats from "@components/features/profile/atom/stats";
import { auth } from "@config/firebase/firbaseConfig";
import theme from "@config/theme";
import { signOut } from "firebase/auth";
import Cookies from "js-cookie";
import { ConnectedProps, connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import { LoaderSnackbarWrapperActions } from "../LoaderSnackbarWrapper/LoaderSnackbarWrapper.slice";
import {
  Container,
  Content,
  ProfileStatsWrapper,
  StatsWrapper,
  Wrapper,
} from "./profileInfo.styled";
import { ComponentProps } from "./profileInfo.type";

type ReduxProps = ConnectedProps<typeof connector>;
declare var _cio: any;

const ProfileInfo = ({
  setUser,
  stats,
  review,
  resetUser,
  setLoader,
}: ReduxProps & ComponentProps) => {
  const navigate = useNavigate();
  return (
    <Container>
      <Content>
        <Wrapper>
          <ProfileStatsWrapper>
            <ProfileStats
              title="/ 5 (games)"
              reviewStat={
                review?.average_game_rating
                  ? review.average_game_rating.toString()
                  : "-"
              }
            />
            <ProfileStats
              title="/ 5 (player)"
              reviewStat={
                review?.average_player_rating
                  ? review.average_player_rating.toString()
                  : "-"
              }
            />
          </ProfileStatsWrapper>
          <StatsWrapper>
            <Stats title="Games" stat={stats.games_played} color="#D75613" />
            <Stats title="Hours" stat={stats.hours_played} color="#0B3B85" />
            <Stats title="Wins" stat={stats.games_won} color="#8D59D1" />
          </StatsWrapper>
        </Wrapper>
        <Button
          iscta
          textColor={theme.palette.error.main}
          text="Log Out"
          type="button"
          color="dark"
          variant="outlined"
          onClick={() => {
            signOut(auth)
              .then(() => {
                setLoader({
                  loader: true,
                  isBlankLoader: true,
                });
                if (_cio.reset) {
                  _cio.reset();
                }
                resetUser();
                localStorage.clear();
                window.location.href = "/";
                // navigate("/");
              })
              .catch((error) => {
                alert(error);
              });
          }}
        />
      </Content>
    </Container>
  );
};

const mapDispatchToProps = {
  setUser: homeActions.setUser,
  resetUser: homeActions.reset,
  setLoader: LoaderSnackbarWrapperActions.setGlobalAppearances,
};

const connector = connect(undefined, mapDispatchToProps);
const ProfileInfoRedux = connector(ProfileInfo);

export { ProfileInfoRedux as ProfileInfo };
